<!--
create by melody on 2018/11/1
description: 操作界面组件
-->
<template>
	<div v-if="isShow">
		<div v-if="isShowPageType === 0">
			<page-header :title="title"></page-header>
			<div v-if="hiddenOrShowStatus == 'show'" class="hdp-uf hdp-uf-dc search-container">
				<el-row :gutter="80">
				 	<el-col v-for="(item, index) in searchOptions" :key="index" v-if="searchItemArr.includes(item.value)" :span="8">
				 		<div class="hdp-uf" style="width:100%;">
				 			<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{item.label + "："}}</div>
				 			<el-select v-if="item.type=='select'" filterable v-model="searchParam[item.value]" :disabled="item.disabled" style="width:60%;" clearable>
				 				<el-option v-for="(item2,index2) in item.list" :key="index2" :label="item2.label" :value="item2.value"></el-option>
				 			</el-select>
                            <el-select v-else-if="item.type=='select2'" filterable v-model="searchParam[item.value]" :disabled="item.disabled" style="width:60%;" clearable>
                                <el-option v-for="(item2,index2) in item.list" :key="index2" :label="$t('m['+ item2.value +']')" :value="item2.value"></el-option>
                            </el-select>
				 			<el-date-picker
				 				v-else-if="item.type=='date'"
					 			v-model="searchParam[item.value]"
					 			type="daterange"
					 			value-format="yyyy-MM-dd"
					 			range-separator="-"
					 			:start-placeholder="$t('m.startDate')"
					 			:end-placeholder="$t('m.endDate')"
					 			style="width:60%;"
					 			>
					 		</el-date-picker>
                            <el-date-picker
                                v-else-if="item.type=='date-single'"
                                v-model="searchParam[item.value]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('m.chooseDate')"
                                style="width:60%;">
                            </el-date-picker>
				 			<el-input v-else v-model="searchParam[item.value]" style="width:60%;" clearable></el-input>
				 		</div>
				 	</el-col>
				</el-row>
				<el-row :gutter="80">
					<el-col :span="8">
						<div class="hdp-uf" style="width:100%;">
							<!-- <el-button type="primary" icon="el-icon-search" @click="getDemoList()"> 查 询 </el-button> -->
                            <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.searchOptions')}}</div>
							<el-select
								v-model="searchItemArr"
								multiple
								collapse-tags
								:placeholder="$t('m.searchOptions')"
								style="width:60%;">
									<el-option
									v-for="item in searchOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.tableOptions')}}</div>
							<el-select
								v-model="tableItemArr"
								:placeholder="$t('m.tableOptions')"
								style="width:60%;"
								multiple
								collapse-tags
								>
								<el-option
									v-for="item in tableOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="table-container" ref="tableContainer" :style="{'margin': marginSize}">
                <div class="hdp-uf">
                    <el-button type="primary" icon="el-icon-view" @click="handleSearch()"> {{hiddenOrShowStatus == 'show' ? $t('m.hiddenSearch') : $t('m.showSearch')}} </el-button>
                    <lap-export-btn class="file-btn" :total="total" :exportType="exportType" :exportUrl="exportAddress"></lap-export-btn>
                </div>
               <!--  <el-button type="primary" icon="el-icon-view" @click="handleSearch()"> {{hiddenOrShowStatus == 'show' ? '隐藏查询条件' : '显示查询条件'}} </el-button>
                <span>
                    <lap-export-btn :total="total" :exportType="exportType" :exportUrl="exportAddress"></lap-export-btn> 
                </span> -->
                
				<!-- <a :href="exportAddress" class="file-btn">
					<el-button type="primary" icon="el-icon-download"> 导出查询结果 </el-button>
				</a> -->
				<el-table ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" @select-all="handleSelectionChange" stripe tooltip-effect="dark" style="margin: 24px 0" max-height="500">
					<el-table-column fixed type="selection" width="35"></el-table-column>
					<el-table-column fixed type="index" width="60"></el-table-column>
					<el-table-column v-if="tableItemArr.includes(item.value)"  v-for="(item, index) in tableOptions" :key="index" :prop="item.value" :label="item.label" show-overflow-tooltip :width="item.width">
						<template  slot-scope="scope">
							<el-button v-if="item.value == 'leaseItemNumber'" @click="handleClick(scope.row)" type="text">{{ scope.row.leaseItemNumber }}</el-button>
							<span v-else>{{ scope.row[item.value]}}</span>
						</template>
					</el-table-column>
				</el-table>

				<div class="hdp-uf-hfs" v-if="pageFrom==='EPOorderLeasing'">
					<a href="./static/template/租赁物件信息上传模板LeaseUploadTemplate.xlsx">
						<el-button type="primary" icon="el-icon-download"> {{$t('m.EPOTemplate')}} </el-button>
					</a>
					<el-button class="file-btn" type="primary" icon="el-icon-upload2" @click="goToOprateUploadPage('EPO')"> {{$t('m.enterUpload')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-upload2" @click="goToOprateUploadPage('YEPO')"> {{$t('m.enterYuanUpload')}} </el-button>
                    <el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handleEpoStop()"> {{$t('m.sureAdvanceEnd')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handleSubmit()"> {{$t('m.submit')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-circle-close-outline" v-bind:disabled="isDisableAction" @click="handleClose()"> {{$t('m.closeBacklog')}} </el-button>
				</div>

				<div class="hdp-uf-hfs" v-if="pageFrom==='UploadOperate'">
					<a href="./static/template/租赁物件信息上传模板LeaseUploadTemplate.xlsx">
						<el-button type="primary" icon="el-icon-download" > {{$t('m.leaseTemplate')}} </el-button>
					</a>
					<el-button class="file-btn" type="primary" icon="el-icon-upload2" @click="goToOprateUploadPage('staff')"> {{$t('m.enterUpload')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handleUploadStop()"> {{$t('m.advanceEnd')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handleIsSub()"> {{$t('m.submit')}} </el-button>
					<el-button type="info" plain icon="el-icon-delete" v-bind:disabled="isDisableAction" @click="handleDelete()"> {{$t('m.delete')}} </el-button>
				</div>

				<div class="hdp-uf-hfs" v-if="pageFrom==='SearchPage'">
					<a href="./static/template/租赁物件信息上传模板LeaseUploadTemplate.xlsx">
                        <el-button type="primary" icon="el-icon-download" > {{$t('m.leaseTemplate')}}  </el-button>
                    </a>
				</div>

				<div class="hdp-uf-hfs" v-if="pageFrom==='FinanceInspect'">
					<el-button type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handlePass('checked')"> {{$t('m.checkPass')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-back" v-bind:disabled="isDisableAction" @click="handleReject('checked')"> {{$t('m.reject')}} </el-button>
				</div>

				<div class="hdp-uf-hfs" v-if="pageFrom==='FinanceReview'">
					<el-button type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="isDisableAction" @click="handlePass('reviewed')"> {{$t('m.reviewPass')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-edit-outline" v-bind:disabled="isDisableAction" @click="handlePosting()"> {{$t('m.postingErp')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-back" v-bind:disabled="isDisableAction" @click="handleReject('reviewed')"> {{$t('m.reject')}} </el-button>
				</div>

				<div class="hdp-uf-hfs" v-if="pageFrom==='ExemptOperation'">
					<el-button type="info" plain icon="el-icon-delete" v-bind:disabled="isDisableAction" @click="handleCloseWaiver()"> {{$t('m.closeWaiver')}} </el-button>
				</div>

				<!-- <div class="hdp-uf" v-if="pageFrom==='UploadPOReceive'">
					<el-button type="primary" icon="el-icon-download" v-bind:disabled="isDisableAction" > 下载 </el-button>
					<el-button type="primary" icon="el-icon-upload2" @click="goToOprateUploadPage"> 进入上传界面 </el-button>
					<el-button type="primary" icon="el-icon-circle-check-outline"  v-bind:disabled="isDisableAction"> 提交 </el-button>
				</div> -->
                <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
			</div>
		</div>
		<OprateDetail :paramsObj="currentDetailObj" @close="isShowPageType = 0" v-else-if="isShowPageType === 1"></OprateDetail>
		<OprateUpload :paramsObj="currentDetailObj" @close="isShowPageType = 0" v-else-if="isShowPageType === 2"></OprateUpload>
        <el-dialog
            :title="$t('m.choose')"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form :model="form" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item v-if="accountTypeFlag == 'erpPost'" :label="$t('m.periodName')" prop="periodName" style="width: 100%">
                        <el-select  v-model="form.periodName">
                            <el-option v-for="(item, index) in accountPeriodList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  v-else :label="$t('m.advanceEndDate')" prop="periodName" style="width: 100%">
                        <el-date-picker
                            width="100%"
                            v-model="form.periodName"
                            :picker-options="pickerOptions0"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('m.chooseDate')">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button v-if="accountTypeFlag == 'erpPost'" type="primary" @click="handleChoosePosting()">{{$t('m.sure')}}</el-button>
                <el-button v-if="accountTypeFlag == 'end'" type="primary" @click="handleHandEnd()">{{$t('m.sure')}}</el-button>
                <el-button v-if="accountTypeFlag == 'epoEnd'" type="primary" @click="handleEpoEnd()">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
	</div>
</template>
<script>
// import { tableOption } from '@/api/mock/constants'
export default {
	name: 'OpratePage',
    // 监听,当路由发生变化的时候执行
    watch:{
        $route(to,from){
            let str = to.path
            this.changePath(str)
        }
    },
	data() {
		return {
			//pageFrom:this.paramsObj.from,
            pageFrom:'',
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
				thirdTitle: ''
			},
			//传递给详情组建的相关参数
			currentDetailObj: {
				from:'',
				fromPageName:'',
				params: {},
				uploadType: '',
				leaseItemNumber: '',
                headerId: '',
                transactionType: '',
			},
			searchParam: {      //查询参数
                ouName: '',
                leaseItemNumber: '',
                leaseItemStatus: '',
                leaseDate: '',
                contractNumber: '',
                transactionType: '',
                leaseItemCategory: '',
                uploader: '',
                epoFinanceBp: '',
                originalLeaseItemNumber: '',
                source: '',
                leaseItemDescription: '',
                uploadedType: '',
                exemptionFlag: '',
                costCenter: '',
                poNumber: '',
                referenceContractNumber: '',
                contractDate: '',
                originalItemNumber: '',
                leaseItemType: '',
                revaluationDate: '',
                earlyTerminateFlag: '',
                earlyTerminateStatus: '',
                pageSize: 10,
				pageNum: 1
            },
            form: {
                leaseItemNumber: '',
                headerId: '',
                periodName: '',
			},
            rules: this.$ruleApi.getRule('accountPeriodRule'),
            //会计期  只能选择当前月之前的
            pickerOptions0: {
                disabledDate: (time) => {
                    var d = new Date()
                    return time.getTime() > d.getTime()
                },
            },
            tableData: [],
            total: 0,
			busEntityList: [],
			transactionList: [],
			uploadStatusList: [],
            costCenterList: [],
            leaseItemTypeList: [],
            terminateFlagList: [{
                label: 'Y',
                value: 'Y'
            },{
                label: 'N',
                value: 'N'
            }],
            terminateStatusList: ['95', '96', '97', '98'],//已提交、已检查、已复核、已过账
            terminateStatusList1: ['95'],//已提交
            terminateStatusList2: ['96', '97', '98'], //已检查、已复核、已过账
			searchOptions: [],
			searchItemArr: [],
			tableOptions: [
            {
                value: 'leaseItemNumber',
                label: this.$t('m.leaseItemNumber'),
                width: 250
            },
            {
                value: 'leaseItemStatusValue',
                label: this.$t('m.leaseItemStatus'),
                width: 150
            },
            {
                value: 'transactionType',
                label: this.$t('m.transactionType'),
                width: 150
            },
            {
                value: 'ouName',
                label: this.$t('m.ouName'),
                width: 250
            },
            {
                value: 'costCenter',
                label: this.$t('m.costCenter'),
                width: 250
            },
            {
                value: 'poNumber',
                label: this.$t('m.poNumber'),
                width: 200
            },
            {
                value: 'contractNumber',
                label: this.$t('m.contractNumber'),
                width: 200
            },
            {
                value: 'vendorName',
                label: this.$t('m.vendorName'),
                width: 250
            },
            {
                value: 'headerSource',
                label: this.$t('m.dataSource'),
                width: 150
            },
            {
                value: 'referenceContractNumber',
                label: this.$t('m.referenceContractNumber'),
                width: 250
            },
            {
                value: 'contractStartDate',
                label: this.$t('m.contractStartDate'),
                width: 150
            }, {
                value: 'contractEndDate',
                label: this.$t('m.contractEndDate'),
                width: 150
            },
            {
                value: 'extensionFlag',
                label: this.$t('m.extensionFlag'),
                width: 150
            },
            {
                value: 'leaseItemCategory',
                label: this.$t('m.leaseItemCategory'),
                width: 200
            }, {
                value: 'leaseItemDescription',
                label: this.$t('m.leaseItemDescription'),
                width: 450
            },
            {
                value: 'leaseStartDate',
                label: this.$t('m.leaseStartDate'),
                width: 150
            }, {
                value: 'leaseEndDate',
                label: this.$t('m.leaseEndDate'),
                width: 150
            }, {
                value: 'leaseItemType',
                label: this.$t('m.leaseItemType'),
                width: 150
            },
            {
                value: 'contractCurrency',
                label: this.$t('m.contractCurrency'),
                width: 150
            }, {
                value: 'purchaseRightFlag',
                label: this.$t('m.purchaseRightFlag'),
                width: 150
            }, {
                value: 'shortTermExemptionFlag',
                label: this.$t('m.shortTermExemptionFlag'),
                width: 160
            }, {
                value: 'lowValueExemptionFlag',
                label: this.$t('m.lowValueExemptionFlag'),
                width: 160
            }, {
                value: 'variableExemptionFlag',
                label: this.$t('m.variableExemptionFlag'),
                width: 150
            },
            {
                value: 'originalLeaseItemNumber',
                label: this.$t('m.originalLeaseItemNumber'),
                width: 250
            },
            {
                value: 'revaluationDate',
                label: this.$t('m.revaluationDate'),
                width: 150
            },
            {
                value: 'uploader',
                label: this.$t('m.uploader'),
                width: 150
            },
            {
                value: 'earlyTerminateFlag',
                label: this.$t('m.earlyTerminateFlag'),
                width: 150
            }, {
                value: 'earlyTerminateStatusDesc',
                label: this.$t('m.earlyTerminateStatus'),
                width: 170
            }, {
                value: 'earlyTerminateOa',
                label: this.$t('m.earlyTerminateOa'),
                width: 200
            }, {
                value: 'earlyTerminateChecker',
                label: this.$t('m.earlyTerminateChecker'),
                width: 200
            }, {
                value: 'earlyTerminateReviewer',
                label: this.$t('m.earlyTerminateReviewer'),
                width: 200
            },
            {
                value: 'earlyTerminateMes',
                label: this.$t('m.earlyTerminateMes'),
                width: 150
            },
            {
                value: 'transitionOption',
                label: this.$t('m.transitionOption'),
                width: 150
            },
            {
                value: 'rejectComment',
                label: this.$t('m.rejectComment'),
                width: 150
            },
            {
                value: 'poVarchargeAccount',
                label: this.$t('m.poVarchargeAccount'),
                width: 200
            },
            {
                value: 'createTime',
                label: this.$t('m.createTime'),
                width: 200
            }],
			tableItemArr: [],
			isDisableAction: true,
			isShowPageType: 0, // 0=操作界面，1=详细界面，2=上传界面
			isShowUploadPage: false,
			deleteDemoIdArr: [], //用于多选，单选存数据
            deleteDemoStatusArr: [], //勾选物件状态
            deleteDemoEndStatusArr: [], //勾选物件提前终止状态
            deleteDemoNumArr: [], //勾选物件编号
            deleteOriginNumArr: [], //原物件编码
            isShow: false,//请求结束显示页面
            accountPeriodList: '',
			dialogVisible: false,
            rowsFlag: [],
            accountTypeFlag: '',// erpPost erp过账、 end 上传提前终止、epoEnd epo确认提前终止
            ouNameFlag: '',
            requestType: 'compute_header',
            hiddenOrShowStatus: 'show',
            marginSize : '32px 0',
            exportType: ''
		}
	},
	computed: {
        exportAddress() {
            //默认没有勾选
            let url
            //勾选
            if(this.deleteDemoIdArr.length) {
                this.exportType = 'choose' 
                url = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                + '/' + this.requestType + '/export?isFull=true&headerIds=' + this.deleteDemoIdArr
                + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
            } else {
                this.exportType = 'noChoose'
                url = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                + '/' + this.requestType + '/export'
                + '?isFull=true&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
                + '&ouName=' + encodeURIComponent(this.searchParam.ouName)
                + '&leaseItemNumber=' + this.searchParam.leaseItemNumber
                + '&leaseItemStatus=' + (this.searchParam.leaseItemStatusFlag ? this.searchParam.leaseItemStatusFlag : this.searchParam.leaseItemStatus)
                + '&leaseDateBegin=' + (this.searchParam.leaseDate ? (this.searchParam.leaseDate[0] ? this.searchParam.leaseDate[0] : '') : '')
                + '&leaseDateEnd=' + (this.searchParam.leaseDate ? (this.searchParam.leaseDate[1] ? this.searchParam.leaseDate[1] : '') : '')
                + '&contractNumber=' + this.searchParam.contractNumber
                + '&transactionType=' + (this.searchParam.transactionTypeFlag ? this.searchParam.transactionTypeFlag : this.searchParam.transactionType)
                + '&leaseItemCategory=' + encodeURIComponent(this.searchParam.leaseItemCategory)
                + '&uploader=' + encodeURIComponent(this.searchParam.uploader)
                + '&epoFinanceBp=' + this.searchParam.epoFinanceBp
                + '&originalLeaseItemNumber=' + this.searchParam.originalLeaseItemNumber
                + '&source=' + this.searchParam.source
                + '&leaseItemDescription=' + this.searchParam.leaseItemDescription
                + '&uploadedType=' + this.searchParam.uploadedType
                + '&exemptionFlag=' + this.searchParam.exemptionFlag
                + '&earlyTerminateFlag=' + this.searchParam.earlyTerminateFlag
                + '&earlyTerminateStatus=' + (this.searchParam.earlyTerminateStatusFlag ? this.searchParam.earlyTerminateStatusFlag : this.searchParam.earlyTerminateStatus)
                + '&costCenter=' + encodeURIComponent(this.searchParam.costCenter)
                + '&poNumber=' + this.searchParam.poNumber
                + '&referenceContractNumber=' + this.searchParam.referenceContractNumber
                + '&contractStartDate=' + (this.searchParam.contractDate ? (this.searchParam.contractDate[0] ? this.searchParam.contractDate[0] : '') : '')
                + '&contractEndDate=' + (this.searchParam.contractDate ? (this.searchParam.contractDate[1] ? this.searchParam.contractDate[1] : '') : '')
                + '&originalItemNumber=' + encodeURIComponent(this.searchParam.originalItemNumber)
                + '&leaseItemType=' + this.searchParam.leaseItemType
                + '&revaluationDate=' + this.searchParam.revaluationDate
                // + '&pageSize=1000'
                // + '&pageNum=1'
            }
            return url
        },
    },
	methods: {
        handleSearch() {
            if(this.hiddenOrShowStatus=='show') {
                this.hiddenOrShowStatus = 'hidden'
                this.marginSize = '0'
            } else {
                this.hiddenOrShowStatus = 'show'
                this.marginSize = '32px 0'
            }
        },
        changePath(path) {
            this.tableData = []
            this.total = 0
            var arr = path.split('/')
            this.pageFrom = arr.pop()//获取数组最后一个元素并返回
            this.currentDetailObj.from = this.pageFrom
            let list = ''
            switch (this.pageFrom) {
                case 'EPOorderLeasing':
                    list = this.$t('m.EPO_ORDER_LEASING')
                break
                case 'UploadOperate':
                    list = this.$t('m.UPLOAD_OPERATE')
                break
                case 'SearchPage':
                    list = this.$t('m.SEARCH_PAGE')
                break
                case 'FinanceInspect':
                    list = this.$t('m.FINANCE_INSPECT')
                break
                case 'FinanceReview':
                    list = this.$t('m.FINANCE_REVIEW')
                break
                case 'ExemptOperation':
                    list = this.$t('m.EXEMPT_OPERATION')
                break
                default:
                break
            }
            this.title.thirdTitle = list
            this.currentDetailObj.fromPageName = list
            this.isShowPageType = 0
            this.changeSearchOption()
            if(this.pageFrom == 'EPOorderLeasing') {
                this.requestType = 'compute_header_epo'
            } else {
                this.requestType = 'compute_header'
            }
        },
        changeSearchOption() {
            this.searchParam.leaseItemStatus = ''
            this.searchParam.leaseItemStatusFlag = ''
            this.searchParam.transactionType = ''
            this.searchParam.transactionTypeFlag = ''
            this.searchParam.earlyTerminateStatus = ''
            this.searchParam.earlyTerminateStatusFlag = ''
            // this.searchParam.earlyTerminateFlag = 'N'
            this.searchOptions.forEach((o,i)=>{
                if(o.value == 'leaseItemStatus') {
                    o.disabled = false
                    o.list = this.uploadStatusList
                }
                //默认事务处类型为除豁免的所有
                if(o.value == 'transactionType') {
                    o.disabled = false
                    o.list = this.getListByValues(this.transactionList3, this.transactionList)
                }
                if(o.value == 'earlyTerminateStatus') {
                    o.list = this.getListByValues(this.terminateStatusList, this.uploadStatusList)
                }
            })
            //处理查询条件
            if ( this.pageFrom === 'EPOorderLeasing' ) { //EPO 查询状态：  代办；  事务处理类型：除豁免的all; 豁免为空
                this.searchParam.leaseItemStatus = '94'
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'leaseItemStatus') {
                        o.disabled = true
                    }
                    if(o.value == 'transactionType') {
                        o.list = this.transactionList
                    }
                })
            } else if (this.pageFrom === 'UploadOperate') {//上传人员手工操作 查询状态：  待提交、已提交、已检查、已复核、已过账、已驳回、已正常终止； 事务处理类型：所有; 豁免:N
                this.searchParam.leaseItemStatus = '119'
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'leaseItemStatus') {
                        o.list = this.getListByValues(this.uploadStatusList2, this.uploadStatusList)
                    }
                    if(o.value == 'transactionType') {
                        o.list = this.transactionList
                    }
                })
            } else if(this.pageFrom === 'SearchPage') { //查询操作 查询状态：  所有；  事务处理类型：所有；  豁免：所有
                this.searchParam.transactionType = ''
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'transactionType') {
                        o.list = this.transactionList
                    }
                    if(o.value == 'leaseItemStatus') {
                        o.list = this.getListByValues(this.uploadStatusList5, this.uploadStatusList)
                    }
                })
            } else if(this.pageFrom === 'FinanceInspect') { //检查操作 查询状态：  已提交；  事务处理类型：除豁免; 豁免:N
                this.searchParam.leaseItemStatus = '95'
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'leaseItemStatus') {
                        o.disabled = true
                    }
                    if(o.value == 'earlyTerminateStatus') {
                        o.list = this.getListByValues(this.terminateStatusList1, this.uploadStatusList)
                    }
                })
            } else if(this.pageFrom === 'FinanceReview') { //审查操作 查询状态：  已检查、已复核、已过账、已正常终止；  事务处理类型：除豁免; 豁免:N
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'leaseItemStatus') {
                        o.list = this.getListByValues(this.uploadStatusList6, this.uploadStatusList)
                    }
                    if(o.value == 'earlyTerminateStatus') {
                        o.list = this.getListByValues(this.terminateStatusList2, this.uploadStatusList)
                    }
                })
            } else if(this.pageFrom === 'ExemptOperation') { //豁免操作 查询状态：  待办、待提交、已关闭；  事务处理类型：豁免；  豁免：Y
                this.searchParam.transactionType = 'EXEMPTION'
                this.searchOptions.forEach((o,i)=>{
                    if(o.value == 'transactionType') {
                        o.disabled = true
                        o.list = this.getListByValues(this.transactionList2, this.transactionList)
                    }
                    if(o.value == 'leaseItemStatus') {
                        o.list = this.getListByValues(this.uploadStatusList4, this.uploadStatusList)
                    }
                })
            }
        },
		getDemoList() {
            this.deleteDemoIdArr = []
            //默认事务处理类型除豁免
            this.searchParam.transactionTypeFlag = this.searchParam.transactionType ? this.searchParam.transactionType: ['SLP', 'RVS', 'RET', 'PAT', 'REV', 'INSERT']
			//处理查询条件
            if(this.pageFrom === 'EPOorderLeasing') { //EPO操作 查询状态：  待办；  事务处理类型：all; 豁免:N
                this.searchParam.transactionTypeFlag = this.searchParam.transactionType ? this.searchParam.transactionType: ''
            } else if (this.pageFrom === 'UploadOperate') {//上传人员手工操作 查询状态：  待提交、已提交、已检查、已复核、已过账、已驳回、已正常终止; 全部事务处理类型; 豁免:N
				this.searchParam.leaseItemStatusFlag = this.searchParam.leaseItemStatus ? this.searchParam.leaseItemStatus: ['119', '95', '96', '97', '98', '105', '99']
                this.searchParam.transactionTypeFlag = this.searchParam.transactionType ? this.searchParam.transactionType: ''
			} else if(this.pageFrom === 'SearchPage') {
                this.searchParam.transactionTypeFlag = this.searchParam.transactionType ? this.searchParam.transactionType: ''
            } else if(this.pageFrom === 'FinanceInspect') { //检查操作 查询状态：  已提交；  事务处理类型：all、租赁期缩短; 豁免:N
				if(this.searchParam.earlyTerminateFlag == 'Y') {
                    this.searchParam.earlyTerminateStatusFlag = this.searchParam.earlyTerminateStatus ? this.searchParam.earlyTerminateStatus : ['95']
                } else {
                    this.searchParam.earlyTerminateStatusFlag = ''
                }
			} else if(this.pageFrom === 'FinanceReview') { //审查操作 查询状态：  已检查、已复核、已过账、已正常终止； 事务处理类型：all; 豁免:N
				this.searchParam.leaseItemStatusFlag = this.searchParam.leaseItemStatus ? this.searchParam.leaseItemStatus : ['96','97','98', '99']
                if(this.searchParam.earlyTerminateFlag == 'Y') {
                    this.searchParam.earlyTerminateStatusFlag = this.searchParam.earlyTerminateStatus ? this.searchParam.earlyTerminateStatus : ['96', '97', '98']
                } else {
                    this.searchParam.earlyTerminateStatusFlag = ''
                }
			} else if(this.pageFrom === 'ExemptOperation') { //豁免操作 查询状态：  已豁免、豁免已关闭；  事务处理类型：豁免；  豁免：Y
                this.searchParam.leaseItemStatusFlag = this.searchParam.leaseItemStatus ? this.searchParam.leaseItemStatus : ['129','130']
            }
            this.$commonFunc.commonRequest('get', '/' + this.requestType +'/list/condition', 'getOperateList', this.searchParam)
            .then(res=>{
            	this.total = res.obj.total
            	if(this.total == 0) {
            		this.tableData = []
            	} else {
            		this.tableData = res.obj.list
            	}
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理单选或多选
        // handleSelect(row) {
        //     this.deleteDemoIdArr = []
        //     this.deleteDemoStatusArr = []
        //     this.deleteDemoEndStatusArr = []
        //     this.deleteDemoNumArr = []
        //     this.deleteOriginNumArr = []
        //     if(row.length) {
        //         for(var i = 0; i < row.length; i++) {
        //             this.deleteDemoIdArr.push(row[i].headerId)
        //             this.deleteDemoStatusArr.push(row[i].leaseItemStatus)
        //             this.deleteDemoEndStatusArr.push(row[i].earlyTerminateStatus)
        //             this.deleteDemoNumArr.push(row[i].leaseItemNumber)
        //             this.deleteOriginNumArr.push(row[i].originalLeaseItemNumber)
        //         }
        //     }
        //     this.rowsFlag = row
        // },
        //EPO提交
        handleSubmit() {
            this.$confirm(this.$t('m.surePass'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
	          	this.$commonFunc.commonRequest('get', '/compute_header_epo/submitted', 'handleOperatePage', { headerIds: this.deleteDemoIdArr })
	            .then(res=>{
	            	this.$message.success(this.$t('m.operateSuccess'));
	                this.getDemoList()
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
	        })
        },
        //关闭待办
        handleClose() {
        	this.$confirm(this.$t('m.sureCloseBacklog'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(() => {
	        	this.$commonFunc.commonRequest('get', '/compute_header_epo/changeClosed', 'handleOperatePage', { headerIds: this.deleteDemoIdArr })
	            .then(res=>{
	                this.$message.success(this.$t('m.operateSuccess'));
	                this.getDemoList()
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
            })
        },
        //通过
        handlePass(type) {

            console.log('type %s',type)
        	if(type !== 'checked') {
                // if(this.deleteDemoStatusArr.length > 1) {
                //     this.$message.info(this.$t('m.singleReviewPass'))
                //     return
                // }
                if(this.deleteDemoStatusArr[0] !== '96' && this.deleteDemoEndStatusArr[0] !== '96') {
                    this.$message.info(this.$t('m.chooseChecked'))
                    return
                }
        	}
        	this.$confirm(this.$t('m.surePass'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(() => {
                let obj = {}
                //复核
                if(type !== 'checked') {
                    obj = { headerIds: this.deleteDemoIdArr }
                } else {//检查
                    obj = { headerIds: this.deleteDemoIdArr }
                }
                console.log('object %s:' + JSON.stringify(obj))
	        	this.$commonFunc.commonRequest('get', '/compute_header/'+ type +'/inspected', 'handleOperatePage', obj)
	            .then(res=>{
	                this.$message.success(this.$t('m.operateSuccess'));
	                this.getDemoList()
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
            })
        },
     
        //过账
        handlePosting() {
            let flag = false
            this.rowsFlag.forEach((o,i)=>{
                if(o.leaseItemStatus !== '97'&& o.leaseItemStatus != '98') {
                    flag = true
                }
            })
            if(flag) {
                this.$message.info(this.$t('m.chooseReviewOrPosting'))
                return
            }
            //批量过账
            this.ouNameFlag = this.rowsFlag[0].ouName
            let isSame = true
            this.rowsFlag.forEach((o,i)=>{
                if(o.ouName !== this.ouNameFlag) {
                    isSame = false
                }
            })
            if(isSame) {
                this.handleMulAccount()
            } else {
                this.$message.info(this.$t('m.chooseSameOU'))
                return
            }
        },
        //过账会计期
        handleMulAccount() {
            this.accountPeriodList = []
            this.$commonFunc.commonRequest('get', '/compute_header/getOUPeriod', 'handleOperatePage', {operatingUnit:this.rowsFlag[0].ouName})
                .then(res=>{
                    if(res.obj && res.obj.length) {
                        let periodName = ''
                        res.obj.forEach((o,i)=>{
                            periodName = o.startDate.substring(0,7)
                            this.accountPeriodList.unshift({label: periodName, value: periodName})
                        })
                        this.form.periodName = ''
                        this.dialogVisible = true
                        this.accountTypeFlag = 'erpPost'
                    } else {
                        this.$message.info(this.$t('m.allPost'))
                    }
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
        },
        //选择过账期
        handleChoosePosting() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$commonFunc.commonRequest('post', '/compute_header/batchPosting', 'handleOperatePage', { headerIds:this.deleteDemoIdArr, periodName:this.form.periodName, ouName: this.ouNameFlag})
                    .then(res=>{
                        this.$message.success(this.$t('m.operateSuccess'));
                        this.dialogVisible = false
                        this.getDemoList()
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                    })
                } else {
                    return false;
                }
            });
        },
        //驳回
        handleReject(type) {
            if(type == 'reviewed') {
                let statusFlag = true
                let endStatusFlag = true
                this.deleteDemoStatusArr.forEach((o, i) => {
                    if(o != '96') {
                        statusFlag = false
                    }
                })
                this.deleteDemoEndStatusArr.forEach((o, i) => {
                    if(o != '96') {
                        endStatusFlag = false
                    }
                })
                if(!statusFlag && !endStatusFlag) {
                    this.$message.info(this.$t('m.onlyRejectChecked'))
                    return
                }
            }
            this.$confirm(this.$t('m.sureReject'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(() => {
	        	this.$prompt(this.$t('m.rejectReason'), this.$t('m.tips'), {
		          confirmButtonText: this.$t('m.sure'),
		          cancelButtonText: this.$t('m.cancel'),
		          inputPattern: /^.{0,40}$/,
		          inputErrorMessage: this.$t('m.lengthMax40')
		        }).then(({ value }) => {
		          	this.$commonFunc.commonRequest('post', '/compute_header/'+ type +'/reject', 'handleOperatePage', { headerIds: this.deleteDemoIdArr,  rejectReason: value})
	            	.then(res=>{
		                this.$message.success(this.$t('m.operateSuccess'));
		                this.getDemoList()
		            })
		            .catch(res=>{
		                this.$message.error(res.message)
		            })
		        })
	        })
        },
        //关闭豁免
        handleCloseWaiver() {
            let endStatusFlag = true
            this.deleteDemoStatusArr.forEach((o, i) => {
                if(o != '129') {
                    endStatusFlag = false
                }
            })
            if(!endStatusFlag) {
                this.$message.info(this.$t('m.chooseExemption'))
                return
            }
        	this.$confirm(this.$t('m.sureCloseExemption'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(() => {
	        	this.$commonFunc.commonRequest('get', '/compute_header/changeExemption', 'handleOperatePage',{ headerIds: this.deleteDemoIdArr})
	        	.then(res=>{
	        		this.$message.success(this.$t('m.operateSuccess'));
	        		this.getDemoList()
	        	})
	        	.catch(res=>{
	        		this.$message.error(res.message)
	        	})
	        })
        },
		handleClick(row) {

            this.currentDetailObj.params = row
            this.currentDetailObj.isShowPageType = 1
            this.currentDetailObj.leaseItemNumber = row.leaseItemNumber
            this.currentDetailObj.headerId = row.headerId
            this.currentDetailObj.transactionType = row.transactionType
            let routeData = this.$router.resolve({ path: '/ItemDetails', query: this.currentDetailObj });
            window.open(routeData.href, '_blank');




		},
		handleSelectionChange(row) {
            this.deleteDemoIdArr = []
            this.deleteDemoStatusArr = []
            this.deleteDemoEndStatusArr = []
            this.deleteDemoNumArr = []
            this.deleteOriginNumArr = []
			if(row.length > 0) {
				this.isDisableAction = false
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].headerId)
                    this.deleteDemoStatusArr.push(row[i].leaseItemStatus)
                    this.deleteDemoEndStatusArr.push(row[i].earlyTerminateStatus)
                    this.deleteDemoNumArr.push(row[i].leaseItemNumber)
                    this.deleteOriginNumArr.push(row[i].originalLeaseItemNumber)
                }
                this.rowsFlag = row
			} else {
				this.isDisableAction = true
                this.rowsFlag = []
			}
		},
		goToOprateUploadPage (type) {
			this.currentDetailObj.uploadType = type
			this.isShowPageType = 2
		},
        //epo确认提前终止
        handleEpoStop() {
            let flag = true
            this.rowsFlag.forEach((o,i)=>{
                if(o.transactionCode != 'RET') {
                    flag = false
                }
            })
            if(!flag) {
                this.$message.info(this.$t('m.chooseAdvanceEnd'))
            } else {
                this.dialogVisible = true
                this.accountTypeFlag = 'epoEnd'
            }
            
        },
		//上传确认提前终止
		handleUploadStop(){
			if( this.deleteDemoNumArr.length > 1 ){
				this.$message.error(this.$t('m.chooseSingle'))
				return
			}
            if( this.deleteDemoStatusArr[0] !== '98'){
                this.$message.error(this.$t('m.choosePosting'))
                return
            }
            this.form.periodName = ''
            this.dialogVisible = true
            this.accountTypeFlag = 'end'
		},
		//选择会计期 手工提前终止
		handleHandEnd(){
			this.$commonFunc.commonRequest('get', '/compute_header/preFinish', 'handleOperatePage', { headerId: this.deleteDemoIdArr[0] , periodName: this.form.periodName})
			.then(res=>{
				this.$message.success(this.$t('m.operateSuccess'));
				this.dialogVisible = false
			})
			.catch(res=>{
				this.$message.error(res.message)
			})
   
		},
        //选择会计期 Epo提前终止
        handleEpoEnd(){
            this.$commonFunc.commonRequest('get', '/compute_header_epo/batch/preFinish', 'handleOperatePage', { headerIds: this.deleteDemoIdArr , periodName: this.form.periodName})
            .then(res=>{
                this.$message.success(this.$t('m.operateSuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
            
        },
		//上传人员删除
		handleDelete(){
			let flag = false
			this.deleteDemoStatusArr.forEach(v=>{
				if( v !== '119' && v !== '105'){
					flag = true
				}
			})
			if(flag) {
				this.$message.info(this.$t('m.chooseSubmitOrPosting'));
				return
			}
			this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(res=>{
				this.$commonFunc.commonRequest('POST', '/compute_header/deleteComputeHeader', 'handleOperatePage', { headerIds: this.deleteDemoIdArr })
				.then(res=>{
					this.$message.success(this.$t('m.operateSuccess'));
					this.deleteDemoIdArr = []
					this.getDemoList()
				})
				.catch(res=>{
					this.$message.error(res.message)
				})
			})
			
		},
		//上传人员提交
		handleIsSub(){
			let flag = false
			this.deleteDemoStatusArr.forEach(v=>{
				if( v !== '119'){
					flag = true
				}
			})
			if(flag) {
				this.$message.info(this.$t('m.chooseSubmit'));
				return;
			}
			this.$confirm(this.$t('m.surePass'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            }).then(res => {
				console.log(this.deleteDemoIdArr)
	          	this.$commonFunc.commonRequest('get', '/compute_header/handSubmitted', 'handleOperatePage', { headerIds: this.deleteDemoIdArr})
	            .then(res=>{
	            	this.$message.success(this.$t('m.operateSuccess'));
	                this.getDemoList()
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
	        })
		},
        getBusEntity() {
            this.$commonFunc.commonRequest('get', '/config/primaryData/getUserCompanyInfo')
            .then(res=>{
                let arr = []
                if(res.obj && res.obj.length) {
                    for(let i = 0; i < res.obj.length; i++) {
                        arr.push({label:res.obj[i], value: res.obj[i]})
                    }
                    this.busEntityList = arr
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //根据value匹配数组霹匹配list
        getListByValues(values, arr) {
            let matchArr = []
            values.forEach((o,i) => {
                arr.forEach((o2, i2) => {
                    if(o2.value == o) {
                        matchArr.push(o2)
                    }
                })
            })
            return matchArr
        },
	},
	async mounted() {
        this.tableOptions.forEach((o,i)=>{
             this.tableItemArr.push(o.value)
        })
        this.getBusEntity()
		// this.busEntityList = await this.$commonFunc.getValueSetList(this.$valueSetObj.BUSINESS_ENTITY)
		this.transactionList = await this.$commonFunc.getValueSetList(this.$valueSetObj.TRANSACTION_TYPE, true)
		this.uploadStatusList = await this.$commonFunc.getDataDicList(this.$dataDicObj.UPLOAD_STATUS, true)
        console.log(JSON.stringify(this.uploadStatusList))

        this.costCenterList = await this.$commonFunc.getValueSetList(this.$valueSetObj.COST_CENTER)
        this.leaseItemTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj.LEASE_ITEM_TYPE)
        // this.searchParam.uploader = this.$store.state.userInfo.userInfoObj.userAccount//默认上传人员为当前登陆的人
        this.transactionList2 = ['EXEMPTION']
        this.transactionList3 = ['SLP', 'RVS', 'RET', 'PAT', 'INSERT', 'REV']
		this.uploadStatusList2 = ['119', '95', '96', '97', '98', '105', '99'] //待提交、已提交、已检查、已复核、已过账、已驳回、已正常终止
        this.uploadStatusList4 = ['129', '130'] //已豁免、豁免已关闭
        this.uploadStatusList5 = ['119', '95', '96', '97', '98', '103', '104', '99', '118', '100', '101', '102', '105', '112', '129','130']//待提交、已提交、已检查、已复核、已过账、已提前终止、已部分终止、已正常终止、已租赁期缩短、已撤回、已调整、已重估、已驳回、已关闭、已豁免、豁免已关闭
        this.uploadStatusList6 = ['96', '97', '98', '99']//已检查、已复核、已过账、已正常终止
		this.searchOptions = [
            {
                value: 'leaseItemNumber',
                label: this.$t('m.leaseItemNumber')
            }, {
                value: 'leaseItemStatus',
                label: this.$t('m.leaseItemStatus'),
                type: 'select2',
                list: this.uploadStatusList
            },{
                value: 'transactionType',
                label: this.$t('m.transactionType'),
                type: 'select',
                list: this.transactionList
            },{
				value: 'ouName',
				label: this.$t('m.ouName'),
				type: 'select',
				list: this.busEntityList
			},
            {
                value: 'costCenter',
                label: this.$t('m.costCenter'),
                type: 'select',
                list: this.costCenterList
            },
            {
                value: 'poNumber',
                label: this.$t('m.poNumber')
            },
            {
                value: 'contractNumber',
                label: this.$t('m.contractNumber')
            },
            {
                value: 'referenceContractNumber',
                label: this.$t('m.referenceContractNumber')
            },
            {
                value: 'contractDate',
                label: this.$t('m.contractDate'),
                type: 'date'
            },
            {
                value: 'leaseItemCategory',
                label: this.$t('m.leaseItemCategory')
            },
            {
				value: 'leaseDate',
				label: this.$t('m.leaseDate'),
				type: 'date'
			},
            {
                value: 'leaseItemType',
                label: this.$t('m.leaseItemType'),
                type: 'select',
                list: this.leaseItemTypeList
            },
            {
                value: 'originalLeaseItemNumber',
                label: this.$t('m.originalLeaseItemNumber')
            },
            {
                value: 'revaluationDate',
                label: this.$t('m.revaluationDate'),
                type: 'date-single'
            },
            {
                value: 'uploader',
                label: this.$t('m.uploader')
            },
            {
                value: 'earlyTerminateFlag',
                label: this.$t('m.earlyTerminateFlag'),
                type: 'select',
                list: this.terminateFlagList
            },
            {
                value: 'earlyTerminateStatus',
                label: this.$t('m.earlyTerminateStatus'),
                type: 'select2',
                list: this.terminateStatusList
            }
			]
        this.searchOptions.forEach((o,i)=>{
            this.searchItemArr.push(o.value)
        })
        this.changePath(window.location.hash)
        this.isShow = true
        
	}
}
</script>
<style scoped lang="scss">
.file-btn{
	margin-left:10px;
}

.hdp-uf-hfs .el-button {
    margin: 5px 10px 5px 0;
}

.el-row {
	margin-bottom: 20px;
	&:first-child {
		margin-bottom: 0;
	}
}
.el-col {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.disabled {
    pointer-events: none;
    cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// src/pages/operate/OperatePage.vue